module.exports = __webpack_public_path__ + "img/bgImg_Header.3c8d116d.jpg";